module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topup"
  }, [_c('div', {
    staticClass: "surplus"
  }, [_c('span', {
    staticClass: "surplus-title"
  }, [_vm._v("钢镚余额")]), _vm._v(" "), _c('span', {
    staticClass: "surplus-count"
  }, [_vm._v(_vm._s(_vm.coin))])]), _vm._v(" "), _c('div', {
    staticClass: "action"
  }, [_c('div', {
    staticClass: "action-info"
  }, [_c('span', {
    staticClass: "action-info-detail"
  }, [_vm._v("10"), _c('font', {
    attrs: {
      "size": "2"
    }
  }, [_vm._v("/币")])], 1), _vm._v(" "), _c('span', {
    staticClass: "action-info-price"
  }, [_vm._v("¥1.00")])]), _vm._v(" "), _c('button', {
    staticClass: "action-topup",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.topupHandler($event)
      }
    }
  }, [_vm._v("确认兑换")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1af78528"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topup/NITopup.vue
// module id = 491
// module chunks = 1